module.exports = __webpack_public_path__ + "img/55dc3d8.svg";